import React from "react";
import { useField } from "formik";
import { CustomFieldSchemaFragment, Option } from "__generated__/graphql";
import { CustomMultiAutocompleteField } from "customField/partials/fields/CustomMultiAutocompleteField";
import { CustomListMultiSelectField } from "customField/partials/fields/CustomListMultiSelectField";

interface IFormikPreviewFormMultiSelectProps {
  name: string;
  labelledById?: string;
  schema?: CustomFieldSchemaFragment | null;
  listView?: boolean;
}
export const FormikPreviewFormMultiSelect: React.FC<
  IFormikPreviewFormMultiSelectProps
> = ({ name, labelledById, schema, listView }) => {
  const [field, meta, helpers] = useField<string>({
    name,
  });

  const setValue = (value: Option[] | null) => {
    value && helpers.setValue(JSON.stringify(value));
  };
  const value = field.value ? (JSON.parse(field.value) as Option[]) : null;

  if (listView) {
    return (
      <CustomListMultiSelectField
        value={value}
        setValue={(value) => setValue(value)}
        labelledById={labelledById}
        schema={schema}
      />
    );
  }
  return (
    <CustomMultiAutocompleteField
      value={value}
      setValue={(value) => setValue(value)}
      labelledById={labelledById}
      schema={schema}
      errorMessage={meta.error}
      touched={meta.touched}
    />
  );
};
